import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useLocation, useNavigate } from 'react-router-dom';
import { store } from '../../configureStore';
import orm from '../../orm';
import { NavNodeTypes } from '../../services/enums';
import { app_updateStore } from '../app/slice';
import MapReactMapGLComponent from '../content/map/MapReactMapGLComponent';
import PageComponent from '../content/page/PageComponent';
import PanoComponent from '../content/pano/PanoComponent';
import PdfFileComponent from '../content/pdfFile/PdfFileComponent';
import { installedExperiencesOrmSelector } from '../experience/selectors';
import { experienceManagerLoadingExperienceIdSelector } from '../experienceManager/selectors';
import NavBarComponent from './NavBarComponent';
import ListComponent from './components/ListComponent';
import MenuComponent from './components/MenuComponent';
import { fetchExperience } from './refresh/refresh';
import { appShowWebNavigationBarSelector } from '../app/selectors';
// import { navNodeExperienceIdSelector, navNodeIdSelector } from './selectors';

// @ts-ignore
// import '/na4web/content_package/contents/page_shared/exp_theme_na_v1.css';

const DEBUG = true;
const debugLog = (msg: string) => {
  if (DEBUG) {
    console.log(msg);
  }
};

export const extractNavNodeId = (location: typeof window.location): string => {

  const nnHash = location.hash;
  let locationStringArray: string[] = nnHash.split('=');
  let nn = locationStringArray[0];
  let navNodeId = nnHash.split('=')[1];
  let result: string = '';

  if (nn === '#nn' && navNodeId.length > 10) {
    result = navNodeId;
  }

  return result;
};

type Props = {
  // children: any;
  // status: any;
};

// const NavNodeComponent = (props: NavNodeComponentScreenProps): any => {
const NavNodeComponent = (props: Props): any => {
  debugLog('Component: NavNodeComponent with props: ' + JSON.stringify(props, null, 2));

  debugLog('R1 : NavNodeComponent - START -  content of REDUX orm');
  debugLog('R2 : NavNodeComponent- ORM REDUX: ' + JSON.stringify(store.getState().orm, null, 2));

  // to obtain the current URL fragment
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const nnHash = location.hash;
  debugLog('R3 : NavNodeComponent --------   Location Hash ');
  debugLog('R4 : NavNodeComponent nnHash : ' + JSON.stringify(nnHash, null, 2));

  // const experienceRootNavNodeId: any = process.env.REACT_APP_experienceRootNavNodeId;
  // const experienceId: any = process.env.REACT_APP_experienceId;

  let experienceId: string = '';
  let navNodeId = nnHash.split('=')[1];

  navNodeId = extractNavNodeId(window.location);
  // TODO: what is a default action if navNodeId is null
  debugLog('R5 : NavNodeComponent navNodeId : ' + navNodeId);
  debugLog('R5-A1 : NavNodeComponent type of navNodeId : ' + (typeof navNodeId));
  debugLog('R5-A2 : NavNodeComponent navNodeId : ' + JSON.stringify(navNodeId, null, 2));
  // if (navNodeId === null || navNodeId === undefined) {
  if (navNodeId == null || navNodeId == undefined || navNodeId == "undefined" || navNodeId == "") {
    // @ts-ignore
    let allExperiences = installedExperiencesOrmSelector(store.getState());
    debugLog('R6 : NavNodeComponent allExperiences : ' + JSON.stringify(allExperiences, null, 2));
    if (allExperiences.length !== 0) {
      experienceId = allExperiences[0].id;
      debugLog('R7: NavNodeComponent experienceId : ' + experienceId);
      navNodeId = allExperiences[0].startNavNodeId;
      debugLog('R8 NavNodeComponent navNodeId : ' + navNodeId);
    }

    debugLog('R9 : NavNodeComponent - allExperiences: ' + JSON.stringify(allExperiences, null, 2));
  }
  debugLog('R10 : NavNodeComponent - navNodeId: ' + navNodeId);

  const loadedExperienceId = useSelector((state) => experienceManagerLoadingExperienceIdSelector(state));
  debugLog('R11 : NavNodeComponent - useSelector - loadedExperienceId : ' + loadedExperienceId);

  const session = orm.session(store.getState().orm);
  const { Experience, NavNode } = session;
  // @ts-ignore
  const currentExperience = Experience.withId(experienceId);
  debugLog('R12 :NavNodeComponent - currentExperience : ' + JSON.stringify(currentExperience, null, 2));

  // @ts-ignore
  const navNode = NavNode.withId(navNodeId);

  // fetchExperience();
  useEffect(() => {
    debugLog('R13 : NavNodeComponent USE EFFECT - START ');
    // @ts-ignore
    const navNodeExists = NavNode.withId(navNodeId);
    debugLog('R14 : NavNodeComponent USE EFFECT START = navNodeExists : ' + JSON.stringify(navNodeExists, null, 2));
    if (navNode === null || navNode === undefined || navNodeId === undefined || navNodeId === null) {
      debugLog('R15 :NavNodeComponent USE EFFECT = navNodeExists : ' + JSON.stringify(navNodeExists, null, 2));
      debugLog('R16 :NavNodeComponent USE EFFECT - BEFORE FETCHING EXPERIENCE ');
      fetchExperience();

      // dispatch(app_updateStore({ key: 'showWebNavigationBar', value: experienceJson.showWebNavigationBar}));

      debugLog('R17 :NavNodeComponent USE EFFECT - AFTER FETCHING EXPERIENCE ');
    }
    debugLog('R18 : NavNodeComponent END OF USE EFFECT');
    // }, [NavNode, navNodeId]);
  }, [NavNode, navNode, navNodeId]);
  // }, []);

  const renderFailure = () => null;

  const renderNavNode = (navNode: any) => {
    let type: NavNodeTypes | null = null;
    if (navNode === null) {
      type = null;
    } else {
      type = navNode.type;
    }

    let navNodeComponent: any = null;

    switch (type) {
      case null: {
        debugLog('S1 : NavNodeComponent - renderNavNode - type is NULL - NavNode Does Not Exist ');
        // @ts-ignore
        navNodeComponent = (
          <>
            <div>This Tour does not contain the item - Try another tour !!!</div>
          </>
        );
        break;
      }
      case NavNodeTypes.list: {
        debugLog('NavNodeComponent - type is ListComponent');
        // @ts-ignore
        navNodeComponent = <ListComponent navNodeId={navNodeId} />;
        break;
      }
      case NavNodeTypes.map: {
        debugLog('S2 : NavNodeComponent - type is MapComponent');
        // @ts-ignore
        // navNodeComponent = <MapComponent navNodeId={navNodeId} />;
        // @ts-ignore
        navNodeComponent = <MapReactMapGLComponent navNodeId={navNodeId} />;
        break;
      }
      case NavNodeTypes.menu: {
        debugLog('S3 : NavNodeComponent - type is Menu');
        // @ts-ignore
        navNodeComponent = <MenuComponent navNodeId={navNodeId} />;
        break;
      }
      case NavNodeTypes.page: {
        debugLog('S4 : NavNodeComponent - type is PageComponent');
        // @ts-ignore
        navNodeComponent = <PageComponent navNodeId={navNodeId} />;
        break;
      }
      case NavNodeTypes.pano: {
        debugLog('S5 : NavNodeComponent - type is PanoComponent');
        // @ts-ignore
        navNodeComponent = <PanoComponent navNodeId={navNodeId} />;
        break;
      }
      case NavNodeTypes.pdf_file: {
        debugLog('S6 : NavNodeComponent - type is PDF');
        // @ts-ignore
        navNodeComponent = <PdfFileComponent navNodeId={navNodeId} />;
        break;
      }
    }

    debugLog('S7 : NavNodeComponent - renderNavNode - navNodeComponent : ' + JSON.stringify(navNodeComponent, null, 2));

    return navNodeComponent;
  };

  const renderSpinnerLoading = () => null;

  const renderSpinnerStart = () => null;

  let startAgainURL: string = '';
  if (currentExperience !== null && currentExperience !== undefined) {
    startAgainURL = `${process.env.REACT_APP_BASENAME}#nn=${currentExperience?.startNavNodeId}`;
  } else {
    startAgainURL = `${process.env.REACT_APP_BASENAME}`;
  }

  if ( navNode != null && navNode !== undefined && navNode.type !== null && navNode.type !== undefined) {
     dispatch(app_updateStore({ key: 'nnHash', value: navNode.id}));
     dispatch(app_updateStore({ key: 'title', value: navNode.name}));
  }

  debugLog('T1 : NavNodeComponent - END : ');
  
   const [show, setShow] = useState(true);
  // const handleClose = () => setShow(false);
  //
  //
  const handleClose = () => {
    setShow(false);
    navigate(-1);

  };

  // debugLog('U1: NavNodeComponent - currentExperience : ' + JSON.stringify(currentExperience, null, 2));
  // const showNavigationBar = currentExperience?.showWebNavigationBar;
  // debugLog('U2: NavNodeComponent - showNavigationBar : ' + JSON.stringify(showNavigationBar, null, 2));
  
  const showWebNavigationBar = appShowWebNavigationBarSelector(store.getState());

  return (
    <>
      {/* <NavBarComponent experienceId={experienceId} navNodeId={navNodeId} /> */}
      {/* { showWebNavigationBar &&
        <NavBarComponent navNodeId={navNodeId} showBrandNameSettings={false} showGoBack={false} showSettings={false} showSharing={false} title={''} />
      } */}

      {renderNavNode(navNode)}
    </>
  );
};

export default NavNodeComponent;

